import { create } from 'zustand';
import { CAMERA } from '../config/constants';
import type { Region } from '../lib/geo';

interface ViewportState {
  /** Visible region from the map bounds; null before the first render. */
  region: Region | null;
  /** iOS-style camera distance derived from the visible latitude span. */
  cameraDistance: number;
  zoom: number;
  /** Increments 300 ms after the camera settles; data loaders key off it. */
  settleTick: number;
  /** True once the MapLibre instance is loaded and attached to mapController. */
  mapReady: boolean;
  setMapReady: (ready: boolean) => void;
  setViewport: (region: Region, cameraDistance: number, zoom: number) => void;
  bumpSettle: () => void;
}

export const useViewportStore = create<ViewportState>((set) => ({
  region: null,
  cameraDistance: CAMERA.defaultDistance,
  zoom: 3.5,
  settleTick: 0,
  mapReady: false,
  setMapReady: (ready) => set({ mapReady: ready }),
  setViewport: (region, cameraDistance, zoom) => set({ region, cameraDistance, zoom }),
  bumpSettle: () => set((s) => ({ settleTick: s.settleTick + 1 })),
}));
